import React from 'react';
import { InfoPanel, useFeatureToggle } from '@css-xp/base';
import { PageBackgroundV2 } from '@css-xp/page-background';
import { ENABLE_DESIGN_ITERATION_1, STATSIG_FEATURE_GATES, routePaths } from '@css-xp/ppc-constants';
import { useGetBillingAdminIdsFromAns } from '@css-xp/ppc-custom-hooks';
import { BillingAndLicensingEmailsSettings } from './billing-and-licensing-emails';
import './emails-notification.scss';

export const EmailNotifications = () => {
  const {
    billingAdminIds,
    didErrorHappenWhileFetchingBillingAdminIds,
    areBillingAdminIdsBeingFetched,
  } = useGetBillingAdminIdsFromAns();
  const [isEnabled] = useFeatureToggle();
  const isNotificationManagedAtBillingProfileLevel = isEnabled(
    STATSIG_FEATURE_GATES.ENABLE_NOTIFICATION_AT_BILLING_PROFILE
  );
  const isDesignIteration1Enabled = isEnabled(ENABLE_DESIGN_ITERATION_1);

  const renderEmailsPlaceholderText = (
    <>
      <p className="emails-text-container">
        Our billing and licensing emails give you important info about transactions and your customer's cloud
        subscriptions, including:
      </p>
      <ul>
        <li>Orders, invoices, and payment reminders.</li>
        <li>Quotes.</li>
        <li>Changes to subscription plans, bill dates, and billing accounts.</li>
      </ul>
    </>
  );

  const heading = 'Emails';

  const breadcrumbsItems = [
    {
      title: 'Home',
      href: routePaths.home,
    },
    {
      title: 'Settings',
      href: routePaths.manageNotifications,
    },
    {
      title: 'Emails',
      href: routePaths.manageNotifications,
    },
  ];

  const renderBody = () => {
    return (
      <>
        <InfoPanel type="information" message={renderEmailsPlaceholderText} />
        <BillingAndLicensingEmailsSettings
          areBillingAdminIdsBeingFetched={areBillingAdminIdsBeingFetched}
          billingAdminIds={billingAdminIds}
          shouldManageBillingProfileNotifications={isNotificationManagedAtBillingProfileLevel}
        />
      </>
    );
  };

  return (
    <div className="emails-notification-setting">
      {isDesignIteration1Enabled ? (
        <PageBackgroundV2 heading={heading} breadcrumbsProps={{ items: breadcrumbsItems }} />
      ) : (
        <h1 className="btm-padding top-padding">{heading}</h1>
      )}
      {isDesignIteration1Enabled ? <div className="pl-8 setting-body-container">{renderBody()}</div> : renderBody()}
    </div>
  );
};
